<script lang="ts">
    import type {AddUserResponse, ContactData, AddedUser, AddedUserError} from "../Types";
    import {addUser} from "../Utils";
    export let contact: ContactData
    async function clickAddUser() {
        let addUsersResponse: AddUserResponse = await addUser(
            contact.phone,
            contact.telegram_contact_id,
            contact.username,
            `${contact.first_name} ${contact.last_name}`,
        );

        let addedUsers: Array<AddedUser> = addUsersResponse?.added || [];
        let hackedUsers: Array<AddedUser> = addUsersResponse?.hacked || [];
        let processedUsers: Array<AddedUser> = addUsersResponse?.processed || [];
        let errorUsers: Array<AddedUserError> = addUsersResponse?.error || [];
        let alertMessage: string = '';

        addedUsers.forEach((addedUser) => {
            if (addedUser.phone === contact.phone) {
                alertMessage = `Додано: ${contact.phone}`;
            }
        });
        hackedUsers.forEach((hackedUser) => {
            if (hackedUser.phone === contact.phone) {
                alertMessage += `Взламано: ${contact.phone} - ${hackedUser.hacked_at}`;
            }
        });
        processedUsers.forEach((processedUser) => {
            if (processedUser.phone === contact.phone) {
                alertMessage += `Було додано раніше: ${contact.phone}, відправлено повідомлень: ${processedUser.total_send_messages}`;
            }
        });
        errorUsers.forEach((errorUser) => {
            alertMessage += `Помилка при додаванні: ${errorUser.telegram_id ?? '-'}, повідомлення: ${errorUser.message}`;
        });

        alert(alertMessage);
    }
</script>
{#if contact && (contact.phone || contact.telegram_contact_id)}
    <button class="btn btn-sm btn-primary"
            title="Додати як нову ціль"
            on:click|preventDefault|stopPropagation={clickAddUser}>
        <i class="bi bi-person-plus"></i>
    </button>
{/if}
